
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { VehicleReviveCenter } from '@/models/inventory/vehiclerevivecenter';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { IDialogOption } from '@/models/dialog';
import {getVehicleReviveListHeaders} from '@/views/admin/vehiclerevivecenter/vehicleReviveCenter';
import {vehicleReviveCenterService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Stores: () => import('@/components/common/store.select.vue'),
        AppGrid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class VehicleReviveCenterListPage extends Base {
    public headers: VHeaders[] = getVehicleReviveListHeaders(this);
    public pagedVehicleReviveCenter: VehicleReviveCenter[] = [];
    public storeId: number = 0;
    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public actions: any[] = [];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('vehicleReviveCenter.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteVehicleReviveCenter();
        },
    };
    public vehicleReviveCenterIdToDelete: number = 0;

    public searched: boolean = false;
    public deleted: boolean = false;

    public flags = {
        loading: false,
    };

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addVehicleReviveCenter') {
            this.$router.push({ name: 'admin.vehiclerevivecenter.add' });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('vehicleReviveCenter.btnAddVehicleReviveCenter'), disabled: false, visible: true, class: 'btn', label: this.$t('vehicleReviveCenter.btnAddVehicleReviveCenter'), click: 'addVehicleReviveCenter', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vehicleReviveCenter');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.getVehicleReviveCenter();
        this.actions = [
            {
                type: 'link',
                icon: 'fas fa-edit',
                title: this.$t('vehicleReviveCenter.reviveCenterGridHeaders.gridAction.edit') as string,
                action: (model: VehicleReviveCenter) => {
                    return {
                        name: 'admin.vehiclerevivecenter.edit',
                        params: {
                            id: model.id,
                        },
                    };
                },
            }
            , {
                type: 'button',
                icon: 'fas fa-trash-alt',
                title: this.$t('vehicleReviveCenter.reviveCenterGridHeaders.gridAction.delete') as string,
                color: 'error',
                action: (model: VehicleReviveCenter) => {
                    this.confirmDelete(model.id);
                },
            }];
        this.pagination.sortBy = 'name';
        this.pagination.descending = false;
    }

    public async getVehicleReviveCenter(): Promise<void> {
        try {
            this.flags.loading = true;
            const resp = await vehicleReviveCenterService.getVehicleReviveCenter();
            this.pagedVehicleReviveCenter = resp.results;

            this.pagination.totalItems = resp.results.length;
        } finally {
            this.flags.loading = false;
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public confirmDelete(id: number): void {
        this.deleteDialog.model = true;
        this.vehicleReviveCenterIdToDelete = id;
    }

    public async deleteVehicleReviveCenter(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await vehicleReviveCenterService.deleteVehicleReviveCenter(this.vehicleReviveCenterIdToDelete);
            this.deleteDialog.model = false;
            this.deleted = true;
            this.showAlert(true,  this.$t('vehicleReviveCenter.alertDeleteVehicleReviveCenter'));
            await this.getVehicleReviveCenter();
        } finally {
            this.deleteDialog.loading = false;
            this.deleteDialog.model = false;
        }
    }
}
